import React from 'react';
import Icon from '../Icon';
import svg from '../icons/status-warning-onlight.js';

const IconStatusWarningOnlight = (props) => <Icon {...props} svg={svg} />;

IconStatusWarningOnlight.displayName = 'IconStatusWarningOnlight';

export default IconStatusWarningOnlight;
